import { HttpErrorResponse } from '@angular/common/http';
import { AfterViewChecked, AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import * as moment from 'moment';
import { Subscription } from 'rxjs';
import { SubSink } from 'subsink';
import { browserRefresh } from '../../../app.component';
import { ApiHandlerService } from '../../../core/api-handlers';
import { AlertService } from '../../../core/services/alert.service';
import { formatDate } from '../../../core/services/format-date';
import { UtilityService } from '../../../core/services/utility.service';
import { FlightService } from '../flight.service';
import { TripInfoComponent } from './flight-details/trip-info/trip-info.component';

@Component({
    selector: 'app-result',
    templateUrl: './result.component.html',
    styleUrls: ['./result.component.scss']
})
export class ResultComponent implements OnInit, AfterViewInit, AfterViewChecked, OnDestroy {
    endSlice: number = 20;
    throttle;
    public browserRefresh: boolean;
    displayedColumns = ['Flights', "Markup Value", 'Markup Type', 'Edit'];
    public flightIcon: string = "assets/images/login-images/assets/flight.png";
    public hotelIcon: string = "assets/images/login-images/assets/material-hotel.png";
    public insuranceIcon: string = "assets/images/login-images/assets/document.png";
    primaryColour: any;
    secondaryColour: any;
    loadingTemplate: any;
    isCollapsed = true;
    isCollapsedSearch = true;
    showMobilefilter = true;
    subscription: Subscription;
    currency = this.flightService.currency;
    tripType = '';
    departureCity = '';
    departureCityModified = '';
    departureDate: any = '';
    destinationCity = '';
    destinationCityModified = '';
    returnDate: any = '';
    traveller: any;
    travellerCount = 1;
    travellerString: any;
    displayCities = [];
    flights: any = [];
    flightsCopy: any = [];
    myValue = 9999;
    minPrice = 1000;
    maxPrice = 9999;
    loading: boolean;
    totalFlights = 0;
    fastestFligtTime = '';
    cheapestFlight: any = 0;
    totalDuration: string = '';
    airline_logo = '';
    serverError = false;
    noFlight = false;
    searchingFlight = false;
    originCountry = '';
    destCountry = '';
    mobileModify: boolean = false;
    protected subs = new SubSink();
    private searchPayload: any;
    Fstops = [
        { id: 1 },
        { id: 2 },
    ]
    onStopSelection(s) {
    }
    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private flightService: FlightService,
        private apiHandlerService: ApiHandlerService,
        private util: UtilityService,
        private cd: ChangeDetectorRef,
        private dialog: MatDialog,
        private alertService: AlertService,
    ) { }

    test = [
        { name: "abc", age: "28" },
        { name: "asbc", age: "208" },
        { name: "abqc", age: "280" },
    ]
    clicked() {
        alert(1);
    }
    ngOnInit() {
        this.browserRefresh = browserRefresh;
        if (this.browserRefresh) {
            this.flightService.loading.next(true);
            this.subs.sink = this.flightService.loading.subscribe(res => {
                this.loading = res;
            });
            let flightSearchPostdata = this.prepareSearchPayloadFromSessionData('flightSearchData');
            this.flightService.formFilled = JSON.parse(sessionStorage.getItem('flightSearchData'));
            this.searchResult(flightSearchPostdata);

        } else {
            this.searchPayload = this.prepareSearchPayloadFromSessionData('flightSearchData');
            this.flightService.formFilled = JSON.parse(sessionStorage.getItem('flightSearchData'));
            this.searchResult(this.searchPayload);
        }
        this.flightService.loading.next(true);
        this.originCountry = this.flightService.originCountry['CountryName'];
        this.destCountry = this.flightService.destCountry['CountryName'];
        this.airline_logo = this.flightService.airline_logo;
        this.subs.sink = this.flightService.searchingFlight.subscribe(res => {
            this.searchingFlight = res;
        });
        this.subs.sink = this.flightService.serverError.subscribe(res => {
            this.serverError = res;
        });
        this.subs.sink = this.flightService.loading.subscribe(res => {
            this.loading = res;
        });
        this.subs.sink = this.flightService.flights.subscribe(res => {
            if (!res.length) {
                this.flights = [];
            } else {
                this.flights = res;
                if (!this.loading) {
                    setTimeout(_ => {
                        this.dialog.closeAll();
                    }, 100);
                }
            }

        });
        this.subs.sink = this.flightService.changeDetectionEmitter.subscribe(
            () => {
                this.cd.detectChanges();
            },
            (err) => {
            }
        );
        this.subs.sink = this.flightService.myValue.subscribe(res => {
            this.myValue = res;
        });
        this.subs.sink = this.flightService.minPrice.subscribe(res => {
            this.minPrice = res;
        });
        this.subs.sink = this.flightService.maxPrice.subscribe(res => {
            this.maxPrice = res;
        });
        this.subs.sink = this.flightService.isCollapsed.subscribe(res => {
            this.isCollapsed = res;
        });

        this.subs.sink = this.flightService.noFlight.subscribe(res => {
            this.noFlight = res;
        });
        this.flightService.loading.next(false);
        this.flightService.dialogClose.next(false);
        this.subs.sink = this.flightService.dialogClose.subscribe(res => {
            if (res)
                this.dialog.closeAll();
        })
        this.flightService.editPassenger.next(false);
        this.mobileModify = this.getIsMobile();
        //this.isCollapsedSearch = false;
        window.onresize = () => {
          this.mobileModify = this.getIsMobile();
          this.isCollapsedSearch = this.getIsMobile();
        };

    }

    onScrollDown(len) {
        if ((len % 20) === 0 && this.endSlice < 500) {
            this.endSlice += 20;
        }
    }

    displaySeats(flight: any) {
        if (flight.FlightDetails.Details[0][0].Attr.hasOwnProperty('AvailableSeats')) {
            return flight.FlightDetails.Details[0][0].Attr.AvailableSeats;
        }
        return false;
    }

    ngAfterViewChecked() {
        this.cd.detectChanges();
    }

    onBookNow(resultTokendata) {
        this.flightService.loading.next(true);
        if (this.flightService.isDevelopment) {
        } else {
            this.flightService.loading.next(true);
            this.subs.sink = this.apiHandlerService.apiHandler('updateFareQuote', 'POST', '', '', {
                ResultToken: resultTokendata.ResultToken,
                booking_source: resultTokendata.booking_source
            }).subscribe(res => {
                if (res.statusCode == 200 || res.statusCode == 201) {
                    if (Object.keys(res.data).length != 0) {
                        res.data.UpdateFareQuote.FareQuoteDetails.JourneyList.Price=res.data.UpdateFareQuote.FareQuoteDetails.JourneyList.Exchange_Price;
                        const journeyListPre = res.data.UpdateFareQuote.FareQuoteDetails;
                        this.flightService.bookingFlightData.next(journeyListPre);
                        this.flightService.resultToken = journeyListPre.JourneyList.ResultToken;
                        this.flightService.bookingSource.next(resultTokendata.booking_source);
                        const randomTwoDigit = Math.floor(Math.random() * 90 + 10);
                        const randomNumber = new Date().valueOf();
                        this.flightService.traveller = this.traveller;
                        this.router.navigate(['/flight/booking']);
                    } else {
                        this.alertService.error(res.Message);
                    }
                } else {
                    this.flightService.loading.next(false);
                    alert(res.Message);
                }
                this.flightService.loading.next(false);
            }, (error: HttpErrorResponse) => {
            });
        }
    }

    ngAfterViewInit() {
        setTimeout(() => {
            this.cd.detectChanges();
        });
    }

    searchResult(data: any) {
        this.util.writeStorage("flightSearchPostdata", data, sessionStorage)
        const params = this.flightService.formFilled;

        if (params) {
            this.tripType = params['tripType'];
            this.flightService.tripType.next(this.tripType);
            if (params['tripType'] == 'Multi-city') {
                this.displayCities = params['cities'];
            } else {
                this.departureCity = params['departureCity'];
                if (params['departureDate'] != '') {
                    if (params['tripType'] == 'Roundtrip') {
                        this.departureDate = moment(params['departureDate']).format("MM/DD/YYYY");
                        this.returnDate = moment(params['returnDate']).format("MM/DD/YYYY");
                    } else {
                        this.departureDate = moment(params['departureDate']).format("MM/DD/YYYY");
                    }
                }
                this.destinationCity = params['destinationCity'];
            }
            if (params['traveller']) {
                this.traveller = params['traveller'];
                this.travellerCount = this.traveller['adults'] + this.traveller['childrens'] + this.traveller['infants'];
                this.travellerString = params['traveller'];
            }

            let config = new MatDialogConfig();
            config.height = '600px';
            config.width = '1000px';
            config.panelClass = "copy-items-modal";
            config.disableClose = true;
            config.data = {
                data: this.flightService.formFilled
            }
            let copyDialog = this.dialog.open(TripInfoComponent, config);
        }
        this.flightService.searchResult(data);
    }

    getAirportCode(parantesis: string) {
        return parantesis.match(/\(([^)]+)\)/)[1]
    }

    resetFilter() {
        this.flightService.resetFilter();
    }

    stops(flight: any) {
        return flight.length - 1;
    }

    stopsAirportCodes(flight: any) {
        const codes = [];
        flight.forEach(e => {
            codes.push(e.Destination.AirportCode);
        });
        codes.pop();
        return codes.join(' -> ');
    }

    duration(flight) {
        return this.flightService.duration(flight);
    }

    flightDataStringify(flight: any) {
        return JSON.stringify(flight);
    }

    checkDays(flight: any) {
        if (typeof flight == 'object') {
            const time = flight;
            const dt = time[0].Origin.DateTime.split(" ");
            let days = 0;
            let dt2: any;
            if (time.length > 1) {
                dt2 = time[time.length - 1].Destination.DateTime.split(" ");
            } else {
                dt2 = time[0].Destination.DateTime.split(" ");
            }
            const origin: any = new Date(dt[0]);
            const destination: any = new Date(dt2[0]);
            days = Math.floor((destination - origin) / (1000 * 60 * 60 * 24));
            return days;
        }
    }

    mobileFilter(){
        this.showMobilefilter = true;
    }

    closeFilter(){
        this.showMobilefilter = false;
    }
    getIsMobile(): boolean {
        
        const w = document.documentElement.clientWidth;
        const breakpoint = 992;
        console.log(w);
        if (w < breakpoint) {
            this.isCollapsedSearch = false;
            this.showMobilefilter = false;
          return true;
        } else {
          return false;
        }
      }

      

    private prepareSearchPayloadFromSessionData(sessionKey: string): any {
        const ssd = JSON.parse(sessionStorage.getItem(sessionKey));
        let segments = [];
        if (ssd.tripType == 'Multi-city') {
            ssd.tripType = 'multicity';
            ssd.cities.forEach((e) => {
                const Origin = e.mDepartureCity;
                const Destination = e.mDestinationCity;
                const DepartureDate = formatDate(e.mDepartureDate, "");
                segments.push({
                    Origin: Origin,
                    Destination:
                        Destination,
                    DepartureDate: DepartureDate + "T00:00:00",
                    CabinClass: ssd.CabinClass
                });
            });
        } else {
            segments = [
                {
                    CabinClass: (ssd.tripType == 'Oneway') ? ssd.CabinClass : undefined,
                    CabinClassOnward: ssd.CabinClass,
                    CabinClassReturn: ssd.CabinClass,
                    DepartureDate: moment(ssd.departureDate).format("YYYY-MM-DD[T]HH:mm:ss"),
                    ReturnDate: (ssd.tripType == 'Roundtrip') ? moment(ssd.returnDate).format("YYYY-MM-DD[T]HH:mm:ss") : undefined,
                    Destination: ssd.destinationCity,
                    Origin: ssd.departureCity
                }
            ];
        }
        let searchReq = {
            AdultCount: ssd.traveller.adults,
            ChildCount: ssd.traveller.childrens,
            InfantCount: ssd.traveller.infants,
            JourneyType: (ssd.tripType == 'Roundtrip') ? 'Return' : ssd.tripType,
            PreferredAirlineName: ssd.PreferredAirline.toLowerCase() == 'all' 
            ? []  : [ssd.PreferredAirline || ''],
            PreferredAirlines:  ssd.PreferredAirline.toLowerCase() == 'all' 
            ? []  : [ssd.PreferredAirline || ''],
            Segments: segments,
            NonStopFlights:ssd.NonStopFlights,
            childDOB:ssd.traveller.childDateOfBirth,
            infantDOB:ssd.traveller.infantDateOfBirth,
            fromPrice: Number(ssd['fromPrice']),
            toPrice: Number(ssd['toPrice']),
        }
        return searchReq;
    }

    getTime(date: any) {
        return date.substr(11, 5);
    }

    utcDate(dateString: string) {
        const format = /[.?]+/;
        if (format.test(dateString)) {
            let newDateString = dateString.split(".");
            return newDateString[0];
        } else {
            return dateString;
        }
    }

    ngOnDestroy() {
        this.subs.unsubscribe();
    }

}

